export default __webpack_public_path__ + "static/media/IMG_4632.1ac4daf8.JPG";